/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Dropdown, Image, InputNumber, TableColumnsType } from "antd";
import TableUi from "../../../../../atoms/Table";
import { useRef, useState } from "react";
import { CrossIcon, DeleteIcon } from "../../../../../atoms/CustomIcons";
import { PopUp } from "../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../atoms/ConfirmDelete";
import { SubServiceType } from "../../../ducks/types";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { MoreOutlined } from "@ant-design/icons";
import EmptyCard from "../../../../../atoms/EmptyCard";
import { updateServiceStatus } from "../../../../CompanySettings/Services/ducks/services";
import MaterialModal from "../MaterialModal";
import AddSubService from "./AddSubService";

interface PropsType {
  data: any[];
  serviceLineId: string;
  companyId: string;
  parentId: string;
  subArchived?: boolean;
  groupedData: any[];
  serviceGroupId: string;
  setActiveRecord?: React.Dispatch<React.SetStateAction<SubServiceType | null>>;
  setActiveType?: React.Dispatch<React.SetStateAction<string | null>>;
  setGroupedData: React.Dispatch<React.SetStateAction<any[]>>;
  laborRate: number;
  frequency?: string;
  groupIndex: number;
  dealsDetailData?: any;
  setHrsPerVisit?: React.Dispatch<React.SetStateAction<number>>;
  setActiveServiceLineId?: React.Dispatch<React.SetStateAction<string>>;
  setTotalLaborHrs?: React.Dispatch<React.SetStateAction<number>>;
  setActiveServiceId?: React.Dispatch<React.SetStateAction<string>>;
  selectSubservicesFunc?: (e: string) => void;
  setSelectedServiceIds?: React.Dispatch<React.SetStateAction<string[]>>;
}

export default function SubServiceTable(props: PropsType) {
  const {
    data,
    serviceLineId,
    // serviceGroupId,
    setActiveRecord,
    setActiveType,
    subArchived,
    setHrsPerVisit,
    setGroupedData,
    setActiveServiceLineId,
    setTotalLaborHrs,
    setActiveServiceId,
    serviceGroupId,
    groupedData,
    dealsDetailData,
    setSelectedServiceIds,
    selectSubservicesFunc,
  } = props;

  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [tableRecord, setTableRecord] = useState<SubServiceType | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isAllDeleteModalOpen, setIsAllDeleteModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [archivePopUp, setArchivePopUp] = useState(false);
  const [materialPopUpVisible, setMaterialPopUpVisible] = useState(false);

  let hrsPerVisit = 0;
  let totalLaborHrs = 0;
  data?.forEach((service: any) => {
    const HourPerVisit = service?.prod_rate
      ? service?.qty / service?.prod_rate || 0
      : 0;
    const laborHours = HourPerVisit * service?.visit || 0;
    hrsPerVisit += laborHours / service?.visit || 0;
    totalLaborHrs += service?.prod_rate ? service?.qty / service?.prod_rate : 0;
  });

  setTotalLaborHrs && setTotalLaborHrs(totalLaborHrs);
  setHrsPerVisit && setHrsPerVisit(hrsPerVisit);

  // const unitCost =
  //   data?.reduce(
  //     (sum: number, item: any) =>
  //       sum +
  //       (item.material
  //         ? item.material.reduce(
  //             (matSum: number, mat: { unit_cost: number }) =>
  //               matSum + (mat.unit_cost || 0),
  //             0
  //           )
  //         : 0),
  //     0
  //   ) || 0;

  // const useRate =
  //   data?.reduce(
  //     (sum: number, item: any) =>
  //       sum +
  //       (item.material
  //         ? item.material.reduce(
  //             (matSum: number, mat: { use_rate: number }) =>
  //               matSum + (mat.use_rate || 0),
  //             0
  //           )
  //         : 0),
  //     0
  //   ) || 0;

  // const avgProdRate =
  //   data && data.length > 0
  //     ? data.reduce(
  //         (sum: number, item: any) => sum + (item.prod_rate || 0),
  //         0
  //       ) / data.length
  //     : 0;

  // console.log("serviceGroupId---", serviceGroupId);

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       icon={<Image src="/images/table/edit-icon.svg" preview={false} />}
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         // navigate(
    //         //   `/company-settings/${parentId}/${tableRecord?.id}/${serviceLineId}/${companyId}`
    //         // );
    //       }}
    //     >
    //       Edit
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      disabled: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          icon={<Image src="/images/table/reset-icon.svg" preview={false} />}
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
        >
          Reset all service numbers to default
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="delete-hover"
          icon={<DeleteIcon />}
          onClick={(e) => {
            e.stopPropagation();
            setIsDeleteModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click(); // Simulate a click to close
            }
          }}
        >
          Remove subservice
        </Button>
      ),
    },
  ];

  const columns: TableColumnsType<SubServiceType> = [
    {
      title: (
        <AddSubService
          serviceGroupId={serviceGroupId}
          setSelectedServiceIds={setSelectedServiceIds}
          selectSubservicesFunc={(e: string) =>
            selectSubservicesFunc && selectSubservicesFunc(e)
          }
        />
      ),
      dataIndex: "name",
      width: 340,
      fixed: "left",
      // sorter: (a, b) =>
      //   (a?.name ?? "").toString().localeCompare((b?.name ?? "").toString()),
      render: (text) =>
        text ? (
          <>
            {text}{" "}
            {subArchived && (
              <span style={{ color: "#98A3A9" }}>(archived)</span>
            )}
          </>
        ) : (
          "-"
        ),
    },
    {
      title: "Visits",
      dataIndex: "visit",
      width: 95,
      align: "right",
      render: (text, record) => {
        return (
          <InputNumber
            value={text ?? 0}
            min={0}
            precision={0}
            style={{
              background: text > 0 ? "transparent" : "#FFF9D9",
              // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
              textAlign: "right",
            }}
            controls={false}
            // onClick={(e) => e.stopPropagation()}
            onChange={(newVisit) => {
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    return {
                      ...serviceLine,
                      service_groups: serviceLine?.service_groups?.map(
                        (group: { id: string; services: [] }) => {
                          return {
                            ...group,
                            services: group.services.map(
                              (service: {
                                entity_id: string;
                                frequency: string;
                                hrs_per_visit: number;
                                visit: number;
                                prod_rate: number;
                                qty: number;
                              }) => {
                                if (service?.entity_id === record?.entity_id) {
                                  let totalMaterialCost = 0;

                                  if (
                                    record?.material &&
                                    record?.material?.length > 0
                                  ) {
                                    record.material.forEach((mat: any) => {
                                      if (mat?.unit_cost && mat?.use_rate) {
                                        const singleTotalNeed =
                                          (service?.qty ?? 0) / mat.use_rate ||
                                          0;
                                        totalMaterialCost +=
                                          singleTotalNeed * mat?.unit_cost || 0;
                                      }
                                    });
                                  }
                                  const HourPerVisit =
                                    service?.qty / service?.prod_rate || 0;
                                  let laborHrs = 1;
                                  if (service?.frequency === "one_time") {
                                    laborHrs = record?.prod_rate
                                      ? (service?.qty ?? 0) / record?.prod_rate
                                      : 0;
                                  } else {
                                    laborHrs = HourPerVisit * newVisit || 0;
                                  }

                                  const totalLaborCost =
                                    laborHrs * serviceLine?.labor_rate || 0;

                                  const totalVCost =
                                    totalLaborCost + totalMaterialCost || 0;

                                  const totalVPrice =
                                    (totalVCost * 100) /
                                    (100 - record?.gross_margin_perc || 0);
                                  return {
                                    ...service,
                                    total_cost: totalVCost,
                                    total_price: totalVPrice,
                                    visit: newVisit,
                                    hrs_per_visit: HourPerVisit,
                                  };
                                }
                                return service;
                              }
                            ),
                          };
                        }
                      ),

                      // service_groups: serviceLine?.service_groups?.map(
                      //   (group: { id: string; services: [] }) => {
                      //     return {
                      //       ...group,
                      //       services: group.services.map(
                      //         (service: {
                      //           entity_id: string;
                      //           qty: number;
                      //           prod_rate: number;
                      //         }) => {
                      //           let singleHrsPerVisit = 0;
                      //           const HourPerVisit =
                      //             Number(service?.qty) /
                      //               Number(service?.prod_rate) || 0;
                      //           const laborHours = HourPerVisit * newVisit || 0;
                      //           singleHrsPerVisit = laborHours / newVisit || 0;

                      //           if (service.entity_id === record?.entity_id) {
                      //             return {
                      //               ...service,
                      //               visit: newVisit,
                      //               hrs_per_visit: singleHrsPerVisit,
                      //             };
                      //           }
                      //           return service;
                      //         }
                      //       ),
                      //     };
                      //   }
                      // ),
                    };
                  }
                  return serviceLine;
                });
              });
            }}
            className="subServiceInput2"
            formatter={(val) => `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(val) => val?.replace(/\$\s?|(,*)/g, "") || ""}
          />
        );
      },
    },
    {
      title: "Quantity",
      dataIndex: "qty",
      width: 135,
      align: "right",
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <InputNumber
              controls={false}
              value={text ?? 0}
              min={0}
              style={{
                background: text > 0 ? "transparent" : "#FFF9D9",
                // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
                textAlign: "right",
              }}
              className="subServiceInput2"
              // onClick={(e) => e.stopPropagation()}
              onChange={(newQty) => {
                setGroupedData((prevData: any) => {
                  return prevData.map((serviceLine: any) => {
                    if (serviceLine.service_line_id === serviceLineId) {
                      // ✅ update only service_groups
                      const updatedGroups = serviceLine?.service_groups?.map(
                        (group: { id: string; services: any[] }) => {
                          // update all services first
                          const updatedServices = group.services.map(
                            (service: any) => {
                              if (service.entity_id === record?.entity_id) {
                                let totalMaterialCost = 0;
                                let totalMaterialPrice = 0;

                                const HourPerVisit =
                                  Number(newQty) / service?.prod_rate || 0;

                                if (
                                  record?.material &&
                                  record?.material?.length > 0
                                ) {
                                  record.material.forEach((mat: any) => {
                                    if (mat?.unit_cost && mat?.use_rate) {
                                      const singleTotalNeed =
                                        (newQty ?? 0) / mat.use_rate || 0;
                                      const singleUnitPrice =
                                        (mat.unit_cost * 100) /
                                        (100 -
                                          Number(service?.gross_margin_perc) ||
                                          0);
                                      totalMaterialCost +=
                                        singleTotalNeed * mat?.unit_cost || 0;
                                      totalMaterialPrice +=
                                        singleTotalNeed * singleUnitPrice || 0;
                                    }
                                  });
                                }

                                let laborHrs = 1;
                                if (service?.frequency === "one_time") {
                                  laborHrs = record?.prod_rate
                                    ? (newQty ?? 0) / record?.prod_rate
                                    : 0;
                                } else {
                                  const HourPerVisit =
                                    newQty / service?.prod_rate || 0;
                                  laborHrs = HourPerVisit * service?.visit || 0;
                                }

                                const laborPrice =
                                  (serviceLine?.labor_rate * 100) /
                                  (100 - service?.gross_margin_perc || 0);

                                const totalLaborCost =
                                  laborHrs * serviceLine?.labor_rate || 0;

                                const totalCost =
                                  totalLaborCost + totalMaterialCost || 0;

                                const totalPrice =
                                  (totalCost * 100) /
                                  (100 - record?.gross_margin_perc || 0);

                                const totalLaborPrice = laborHrs * laborPrice;

                                return {
                                  ...service,
                                  qty: newQty,
                                  hrs_per_visit: HourPerVisit,
                                  total_cost: totalCost,
                                  total_price: totalPrice,
                                  total_labor_cost: totalLaborCost,
                                  total_labor_price: totalLaborPrice,
                                  total_material_cost: totalMaterialCost,
                                  total_material_price: totalMaterialPrice,
                                  material: service?.material?.map(
                                    (mat: any) => {
                                      return {
                                        ...mat,
                                        total_cost: newQty * mat?.unit_cost,
                                        total_need:
                                          service?.frequency === "one_time"
                                            ? newQty / mat?.use_rate
                                            : newQty *
                                              mat?.use_rate *
                                              service?.visit,
                                        total_price:
                                          (newQty * mat?.unit_cost * 100) /
                                          (100 - mat?.gross_margin_perc),
                                      };
                                    }
                                  ),
                                };
                              }
                              return service;
                            }
                          );

                          // ✅ roll up totals for this group
                          const groupTotals = updatedServices.reduce(
                            (sum: any, svc: any) => {
                              sum.cost += svc.total_cost || 0;
                              sum.price += svc.total_price || 0;
                              return sum;
                            },
                            { cost: 0, price: 0 }
                          );

                          return {
                            ...group,
                            services: updatedServices,
                            total_cost: groupTotals.cost,
                            total_price: groupTotals.price,
                          };
                        }
                      );

                      // ✅ roll up totals from groups
                      const groupsTotals = updatedGroups.reduce(
                        (sum: any, g: any) => {
                          g.services.forEach((svc: any) => {
                            sum.cost += svc.total_cost || 0;
                            sum.price += svc.total_price || 0;
                          });
                          return sum;
                        },
                        { cost: 0, price: 0 }
                      );

                      // ✅ roll up static services (not modified by newQty)
                      const servicesTotals = serviceLine.services?.reduce(
                        (sum: any, svc: any) => {
                          sum.cost += svc.total_cost || 0;
                          sum.price += svc.total_price || 0;
                          return sum;
                        },
                        { cost: 0, price: 0 }
                      );

                      const total_cost =
                        groupsTotals?.cost + servicesTotals?.cost;
                      const total_price =
                        groupsTotals?.price + servicesTotals?.price;

                      return {
                        ...serviceLine,
                        service_groups: updatedGroups,
                        total_cost,
                        total_price,
                      };
                    }
                    return serviceLine;
                  });
                });
              }}
              formatter={(val) =>
                `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(val) => val?.replace(/\$\s?|(,*)/g, "") || ""}
            />{" "}
            <span
              style={{ color: "#6C7478", fontSize: "14px", fontWeight: 400 }}
            >
              {record?.unit ?? ""}
            </span>
          </div>
        );
      },
    },
    {
      title: "Production rate",
      dataIndex: "prod_rate",
      width: 160,
      align: "right",
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
          <InputNumber
            value={text ?? 0}
            className="subServiceInput2"
            style={{
              background: text > 0 ? "transparent" : "#FFF9D9",
              // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
              textAlign: "right",
            }}
            controls={false}
            onChange={(e) => {
              const newProdRate = Number(e);
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    // update service_groups
                    const updatedGroups = serviceLine?.service_groups?.map(
                      (group: { id: string; services: any[] }) => {
                        const updatedServices = group.services.map(
                          (service: any) => {
                            if (service.entity_id === record?.entity_id) {
                              let totalMaterialCost = 0;
                              if (
                                record?.material &&
                                record?.material?.length > 0
                              ) {
                                record.material.forEach((mat: any) => {
                                  if (mat?.unit_cost && mat?.use_rate) {
                                    const singleTotalNeed =
                                      (record?.qty ?? 0) / mat.use_rate || 0;
                                    totalMaterialCost +=
                                      singleTotalNeed * mat?.unit_cost || 0;
                                  }
                                });
                              }
                              // recalculate HourPerVisit and laborHrs
                              const HourPerVisit =
                                (record?.qty ?? 0) / newProdRate || 0;
                              let laborHrs = 1;
                              if (service?.frequency === "one_time") {
                                laborHrs = newProdRate
                                  ? (record?.qty ?? 0) / newProdRate
                                  : 0;
                              } else {
                                laborHrs = HourPerVisit * (service?.visit || 0);
                              }
                              const totalLaborCost =
                                laborHrs * (serviceLine?.labor_rate || 0);
                              const totalCost =
                                totalLaborCost + totalMaterialCost || 0;
                              const totalPrice = totalCost
                                ? (totalCost * 100) /
                                  (100 - (record?.gross_margin_perc || 0))
                                : 0;
                              return {
                                ...service,
                                prod_rate: newProdRate,
                                hrs_per_visit: HourPerVisit,
                                total_cost: totalCost,
                                total_price: totalPrice,
                              };
                            }
                            return service;
                          }
                        );
                        // roll up totals for this group
                        const groupTotals = updatedServices.reduce(
                          (sum: any, svc: any) => {
                            sum.cost += svc.total_cost || 0;
                            sum.price += svc.total_price || 0;
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        );
                        return {
                          ...group,
                          services: updatedServices,
                          total_cost: groupTotals.cost,
                          total_price: groupTotals.price,
                        };
                      }
                    );
                    // roll up totals from updated groups
                    const groupsTotals = updatedGroups.reduce(
                      (sum: any, g: any) => {
                        g.services.forEach((svc: any) => {
                          sum.cost += svc.total_cost || 0;
                          sum.price += svc.total_price || 0;
                        });
                        return sum;
                      },
                      { cost: 0, price: 0 }
                    );
                    // roll up totals from untouched services array
                    const servicesTotals = serviceLine.services?.reduce(
                      (sum: any, s: any) => {
                        sum.cost += s.total_cost || 0;
                        sum.price += s.total_price || 0;
                        return sum;
                      },
                      { cost: 0, price: 0 }
                    ) || { cost: 0, price: 0 };
                    const total_cost = groupsTotals.cost + servicesTotals.cost;
                    const total_price =
                      groupsTotals.price + servicesTotals.price;
                    return {
                      ...serviceLine,
                      service_groups: updatedGroups,
                      total_cost,
                      total_price,
                    };
                  }
                  return serviceLine;
                });
              });
            }}
            formatter={(val) => `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
            parser={(val) => val?.replace(/\$\s?|(,*)/g, "") || ""}
          />
          <span style={{ color: "#6C7478", fontSize: "14px" }}>
            {record?.unit}/hr
          </span>
        </div>
      ),
    },
    // {
    //   title: "Hrs per visit",
    //   dataIndex: "hrs_per_visit",
    //   width: 110,
    //   align: "right",
    //   render: (text) =>
    //     text ? Number(text.toFixed(2) || 0).toLocaleString() : 0,
    // },
    // {
    //   title: "Labor hrs ",
    //   dataIndex: "labor_hrs",
    //   width: 110,
    //   align: "right",
    //   render: (text) =>
    //     text ? Number(text.toFixed(2) || 0).toLocaleString() : 0,
    // },
    // {
    //   title: "Labor price",
    //   dataIndex: "labor_price",
    //   width: 134,
    //   align: "right",
    //   render: (text, record) => {
    //     return (
    //       <InputNumber
    //         value={text ?? 0}
    //         className="subServiceInput2"
    //         style={{
    //           background: text > 0 ? "transparent" : "#FFF9D9",
    //           // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
    //           textAlign: "right",
    //         }}
    //         controls={false}
    //         onChange={(e) =>
    //           setGroupedData((prevData) => {
    //             return prevData.map((serviceLine) => {
    //               if (serviceLine.service_line_id === serviceLineId) {
    //                 return {
    //                   ...serviceLine,
    //                   service_groups: serviceLine.service_groups.map(
    //                     (group: { id: string; services: [] }) => {
    //                       if (group.id === serviceGroupId) {
    //                         return {
    //                           ...group,
    //                           services: group.services.map(
    //                             (service: { entity_id: string }) => {
    //                               if (service.entity_id === record?.entity_id) {
    //                                 return {
    //                                   ...service,
    //                                   labor_price: parseFloat(e.target.value),
    //                                 };
    //                               }
    //                               return service;
    //                             }
    //                           ),
    //                         };
    //                       }
    //                       return group;
    //                     }
    //                   ),
    //                 };
    //               }
    //               return serviceLine;
    //             });
    //           })
    //         }
    //         formatter={(val) => `${val}`?.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
    //         parser={(val) => val?.replace(/\$\s?|(,*)/g, "") || ""}
    //       />
    //     );
    //   },
    // },
    // {
    //   title: "Total labor cost",
    //   dataIndex: "total_labor_cost",
    //   width: 140,
    //   align: "right",
    //   render: (text) =>
    //     text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    // },
    // {
    //   title: "Total labor price",
    //   dataIndex: "total_labor_price",
    //   width: 150,
    //   align: "right",
    //   render: (text) =>
    //     text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    // },
    // {
    //   title: "Total material cost",
    //   dataIndex: "total_material_cost",
    //   width: 160,
    //   align: "right",
    //   render: (text) =>
    //     text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    // },
    // {
    //   title: "Total material price",
    //   dataIndex: "total_material_price",
    //   width: 160,
    //   align: "right",
    //   render: (text) =>
    //     text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    // },
    {
      title: "Total cost",
      dataIndex: "total_cost",
      width: 134,
      ellipsis: true,
      align: "right",
      render: (text) =>
        text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    },
    {
      title: "Total price",
      dataIndex: "total_price",
      width: 134,
      ellipsis: true,
      align: "right",
      render: (text) =>
        text ? `$ ${Number(text.toFixed(2) || 0).toLocaleString()}` : 0,
    },
    // {
    //   title: "Labor GM",
    //   dataIndex: "labor_gross_margin_perc",
    //   width: 120,
    //   align: "right",
    //   render: (text) =>
    //     text ? `${Number(text.toFixed(2) || 0).toLocaleString()}%` : 0,
    //   // render: (text) => (
    //   //   <InputNumber
    //   //     value={text}
    //   //     style={{
    //   //       background: text > 0 ? "transparent" : "#FFF9D9",
    //   //       // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
    //   //       textAlign: "right",
    //   //     }}
    //   //     addonAfter={<span>%</span>}
    //   //     controls={false}
    //   //     // onClick={(e) => e.stopPropagation()}
    //   //     max={99}
    //   //     className={
    //   //       text > 0 ? "subServiceInput" : "showYellow subServiceInput"
    //   //     }
    //   //   />
    //   // ),
    // },
    // {
    //   title: "Material GM",
    //   dataIndex: "material_gross_margin_perc",
    //   width: 140,
    //   align: "right",
    //   render: (text) =>
    //     text ? `${Number(text.toFixed(2) || 0).toLocaleString()}%` : 0,
    //   // render: (text) => (
    //   //   <InputNumber
    //   //     value={text}
    //   //     style={{
    //   //       background: text > 0 ? "transparent" : "#FFF9D9",
    //   //       // border: text > 0 ? "1px solid transparent" : "1px solid #dee5e6",
    //   //       textAlign: "right",
    //   //     }}
    //   //     addonAfter={<span>%</span>}
    //   //     controls={false}
    //   //     // onClick={(e) => e.stopPropagation()}
    //   //     max={99}
    //   //     className={
    //   //       text > 0 ? "subServiceInput" : "showYellow subServiceInput"
    //   //     }
    //   //   />
    //   // ),
    // },
    {
      title: "GM",
      dataIndex: "gross_margin_perc",
      width: 120,
      align: "right",
      render: (text, record) => {
        return (
          <InputNumber
            value={text ?? 0}
            min={0}
            style={{
              textAlign: "right",
            }}
            className={
              text > 0 ? "subServiceInput" : "showYellow subServiceInput"
            }
            addonAfter={<span>%</span>}
            controls={false}
            // onClick={(e) => e.stopPropagation()}
            max={99}
            onChange={(newGM) => {
              setGroupedData((prevData: any) => {
                return prevData.map((serviceLine: any) => {
                  if (serviceLine.service_line_id === serviceLineId) {
                    // ✅ update service_groups
                    const updatedGroups = serviceLine?.service_groups?.map(
                      (group: { id: string; services: any[] }) => {
                        // update all services first
                        const updatedServices = group.services.map(
                          (service: any) => {
                            if (service.entity_id === record?.entity_id) {
                              let totalMaterialCost = 0;

                              if (
                                record?.material &&
                                record?.material?.length > 0
                              ) {
                                record.material.forEach((mat: any) => {
                                  if (mat?.unit_cost && mat?.use_rate) {
                                    const singleTotalNeed =
                                      (record?.qty ?? 0) / mat.use_rate || 0;
                                    totalMaterialCost +=
                                      singleTotalNeed * mat?.unit_cost || 0;
                                  }
                                });
                              }

                              let laborHrs = 1;
                              if (service?.frequency === "one_time") {
                                laborHrs = record?.prod_rate
                                  ? (record?.qty ?? 0) / record?.prod_rate
                                  : 0;
                              } else {
                                const HourPerVisit =
                                  (record?.qty ?? 0) / service?.prod_rate || 0;
                                laborHrs = HourPerVisit * (service?.visit || 0);
                              }

                              const totalLaborCost =
                                laborHrs * (serviceLine?.labor_rate || 0);

                              const totalCost =
                                totalLaborCost + totalMaterialCost || 0;

                              const totalPrice = totalCost
                                ? (totalCost * 100) / (100 - (newGM || 0))
                                : 0;

                              return {
                                ...service,
                                gross_margin_perc: newGM,
                                total_cost: totalCost,
                                total_price: totalPrice,
                              };
                            }
                            return service;
                          }
                        );

                        // ✅ roll up totals for this group
                        const groupTotals = updatedServices.reduce(
                          (sum: any, svc: any) => {
                            sum.cost += svc.total_cost || 0;
                            sum.price += svc.total_price || 0;
                            return sum;
                          },
                          { cost: 0, price: 0 }
                        );

                        return {
                          ...group,
                          services: updatedServices,
                          total_cost: groupTotals.cost,
                          total_price: groupTotals.price,
                        };
                      }
                    );

                    // ✅ roll up totals from updated groups
                    const groupsTotals = updatedGroups.reduce(
                      (sum: any, g: any) => {
                        g.services.forEach((svc: any) => {
                          sum.cost += svc.total_cost || 0;
                          sum.price += svc.total_price || 0;
                        });
                        return sum;
                      },
                      { cost: 0, price: 0 }
                    );

                    // ✅ roll up totals from untouched services array
                    const servicesTotals = serviceLine.services?.reduce(
                      (sum: any, s: any) => {
                        sum.cost += s.total_cost || 0;
                        sum.price += s.total_price || 0;
                        return sum;
                      },
                      { cost: 0, price: 0 }
                    ) || { cost: 0, price: 0 };

                    const total_cost = groupsTotals.cost + servicesTotals.cost;
                    const total_price =
                      groupsTotals.price + servicesTotals.price;

                    return {
                      ...serviceLine,
                      service_groups: updatedGroups,
                      total_cost,
                      total_price,
                    };
                  }
                  return serviceLine;
                });
              });
            }}
          />
        );
      },
    },
    // {
    //   title: "Materials",
    //   dataIndex: "no_of_materials",
    //   width: 140,
    //   render: (text, record) =>
    //     text ? (
    //       <Tag
    //         onClick={(e) => {
    //           e.stopPropagation();
    //           setTableRecord(record);
    //           setMaterialPopUpVisible(true);
    //         }}
    //       >
    //         {text === 1 ? `${text} material` : `${text} materials`}
    //       </Tag>
    //     ) : (
    //       "-"
    //     ),
    // },
    // {
    //   title: "Who performs",
    //   dataIndex: "who_performs",
    //   width: 140,
    //   render: (text) =>
    //     text ? (
    //       <Tag
    //         className={
    //           text === "in_house"
    //             ? "violet_tag defaultTag"
    //             : "orange_tag defaultTag"
    //         }
    //       >
    //         {text === "in_house" ? "In-house" : "Subcontracted"}
    //       </Tag>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      title: <Image src="/images/table/menu-burger.svg" preview={false} />,
      dataIndex: "action",
      width: 52,
      fixed: "right",
      render: (_text, record) => (
        <Dropdown
          menu={{
            items,
          }}
          trigger={["click"]}
          placement="bottomRight"
          className="actionButton"
        >
          <Button
            onClick={(e) => {
              setTableRecord(record);
              e.stopPropagation();
            }}
            onKeyDown={(e) => e.stopPropagation()}
            style={{
              padding: "6px",
              height: "auto",
              background: "transparent",
            }}
            className="only_icon"
            icon={<MoreOutlined />}
            ref={dropdownRef}
          />
        </Dropdown>
      ),
    },
  ];

  const archiveFunction = () => {
    setLoading(true);
    const payload = {
      status: tableRecord?.status === "active" ? "archived" : "active",
    };
    updateServiceStatus(tableRecord?.id as string, payload)
      .then(() => {
        setLoading(false);
        setArchivePopUp(false);
        SuccessMessage(
          `Service ${
            tableRecord?.status === "active" ? "archived" : "activated"
          } .`
        );
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const deleteFunction = () => {
    setLoading(true);
    setGroupedData((prevData: any) => {
      return prevData
        .map((serviceLine: any) => {
          if (serviceLine.service_line_id === serviceLineId) {
            // Filter services from service_groups
            const filteredGroups = (serviceLine.service_groups || [])
              .map((group: any) => {
                const filteredServices = (group.services || []).filter(
                  (service: any) => service.entity_id !== tableRecord?.entity_id
                );
                return {
                  ...group,
                  services: filteredServices,
                };
              })
              .filter((group: any) => group.services.length > 0); // Keep only groups with services

            // Optionally filter top-level services too (if any exist directly)
            const remainingTopLevelServices = (
              serviceLine.services || []
            ).filter(
              (service: any) => service.entity_id !== tableRecord?.entity_id
            );

            // If no services remain in both groups and top-level, return null to remove this serviceLine
            if (
              filteredGroups.length === 0 &&
              remainingTopLevelServices.length === 0
            ) {
              return null;
            }

            return {
              ...serviceLine,
              service_groups: filteredGroups,
              services: remainingTopLevelServices,
            };
          }
          return serviceLine;
        })
        .filter(Boolean); // Remove any null serviceLines
    });
    setLoading(false);
    setIsDeleteModalOpen(false);
    setIsAllDeleteModalOpen(false);

    // const tableId =
    //   selectedRowKeys?.length > 0 ? selectedRowKeys : [tableRecord?.id || ""];
    // deleteService(tableId)
    //   .then(() => {
    //     setLoading(false);
    //     setIsDeleteModalOpen(false);
    //     setIsAllDeleteModalOpen(false);
    //     SuccessMessage("Subservice deleted");
    //   })
    //   .catch((e: unknown) => {
    //     if (e instanceof AxiosError) {
    //       setLoading(false);
    //       ErrorMessage(
    //         e?.response?.data?.error?.message ?? "Something went wrong"
    //       );
    //     } else {
    //       setLoading(false);
    //       ErrorMessage("Something went wrong");
    //     }
    //   });
  };

  const confirmArchive = {
    visibility: archivePopUp,
    content: (
      <ConfirmDelete
        title=""
        isArchivePopup={true}
        onClose={() => setArchivePopUp(false)}
        heading={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        paragraph={
          <>
            Are you sure you want to archive <b>{tableRecord?.name}</b>?<br />
            <br />
            This {tableRecord?.type === "simple"
              ? "service"
              : "subservice"}{" "}
            won’t be available for use.
          </>
        }
        btnText={
          tableRecord?.type === "simple"
            ? "Archive service"
            : "Archive subservice"
        }
        btnApi={archiveFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setArchivePopUp(false),
  };

  const confirmDeletePopUp = {
    visibility: isDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsDeleteModalOpen(false)}
        heading="Remove subservice from estimate"
        paragraph={
          <>
            Are you sure you want to remove <b>{tableRecord?.name}</b>?<br />{" "}
            <br />
            This action cannot be undone.
          </>
        }
        btnText="Remove subservice"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsDeleteModalOpen(false),
  };

  const deleteAllUsersPopUp = {
    visibility: isAllDeleteModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsAllDeleteModalOpen(false)}
        heading="Confirm deletion"
        paragraph={
          <>
            Are you sure you want to delete the selected services? <br />
            This action cannot be undone.
          </>
        }
        btnText="Delete services"
        btnApi={deleteFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsAllDeleteModalOpen(false),
  };

  console.log("tableRecord", tableRecord);

  const materialPopUp = {
    visibility: materialPopUpVisible,
    class: "material_modal",
    content: (
      <MaterialModal
        tableId={tableRecord?.entity_id || ""}
        materialData={data || []}
        dealsDetailData={dealsDetailData}
        serviceLineId={serviceLineId}
        groupedData={groupedData}
        setGroupedData={setGroupedData}
        onClose={() => setMaterialPopUpVisible(false)}
      />
    ),
    width: 1872,
    onCancel: () => setMaterialPopUpVisible(false),
  };

  const onClickRow = (record: SubServiceType) => {
    return {
      onClick: () => {
        setActiveType && setActiveType("simpleSubService");
        setActiveRecord && setActiveRecord(record);
        setActiveServiceLineId && setActiveServiceLineId(serviceLineId);
        setActiveServiceId && setActiveServiceId(record?.entity_id ?? "");
      },
    };
  };

  return (
    <>
      <div className="estimate_table">
        <TableUi<SubServiceType>
          columns={
            data?.some((item) => item.frequency !== "one_time")
              ? columns
              : columns.filter(
                  (col) =>
                    "dataIndex" in col &&
                    col.dataIndex !== "visit" &&
                    col.dataIndex !== "hrs_per_visit"
                )
          }
          data={{
            count: data?.length,
            data: data || [],
          }}
          pageSize={limit}
          setPageSize={setLimit}
          setCurrentPage={setPagination}
          currentPage={pagination}
          selectedRowKeys={selectedRowKeys}
          setSelectedRowKeys={setSelectedRowKeys}
          onClickRow={onClickRow}
        />
      </div>
      {data?.length === 0 && (
        <div className="empty_wrap">
          <EmptyCard
            imageHeight={70}
            title={
              subArchived
                ? "There are no archived subservices"
                : "There are no active subservices"
            }
            description=""
            image={
              subArchived
                ? "/images/empty-icons/no-archived.svg"
                : "/images/empty-icons/no-active.svg"
            }
          />
        </div>
      )}

      {selectedRowKeys?.length !== 0 ? (
        <div className="selection_bar" style={{ minWidth: "235px" }}>
          <div className="selected_count">
            <Button
              icon={<CrossIcon style={{ color: "white" }} />}
              className="only_icon"
              type="text"
              onClick={() => setSelectedRowKeys([])}
            />
            {selectedRowKeys.length}{" "}
            {`${selectedRowKeys.length === 1 ? "service " : "services "}`}
            selected
          </div>
          <div className="selection_buttons">
            <Button
              type="text"
              icon={<DeleteIcon />}
              onClick={() => {
                setIsAllDeleteModalOpen(true);
              }}
            >
              Delete
            </Button>
          </div>
        </div>
      ) : null}

      <PopUp {...confirmArchive} />
      <PopUp {...confirmDeletePopUp} />
      <PopUp {...deleteAllUsersPopUp} />
      <PopUp {...materialPopUp} />
    </>
  );
}
